// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const zacian_crowned: PokeData = {
  "id": 10188,
  "name": "zacian-crowned",
  "height": 28,
  "weight": 3550,
  "base_experience": 360,
  "types": [
    PokeType.FAIRY,
    PokeType.STEEL
  ],
  "api_moves": [
    "swords-dance",
    "bite",
    "quick-attack",
    "slash",
    "metal-claw",
    "crunch",
    "howl",
    "close-combat",
    "giga-impact",
    "iron-head",
    "quick-guard",
    "sacred-sword",
    "noble-roar",
    "moonblast",
    "laser-focus"
  ],
  "moves": [
    "bite",
    "quick-attack",
    "metal-claw",
    "crunch",
    "close-combat",
    "moonblast",
    "misty-terrain",
    "iron-defense",
    "magnet-bomb",
    "dazzling-gleam",
    "mist-terrain",
    "magnet-pull"
  ],
  "evolution_chain": {
    "id": 467,
    "item": null,
    "species": [
      {
        "name": "zacian",
        "order": 888,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 104,
    "speed": 148,
    "ability_power": 150
  },
  "stat_changes": [],
  "catch_rate": 10,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
